import differenceInCalendarDays from 'date-fns/difference_in_calendar_days'
import Model from './Model'

const ACCESSES = {
  reports: 'REPORTS',
  sms: 'SMS',
  api: 'API',
  customization: 'CUSTOMIZATION',
  team: 'TEAM',
  premium: 'PREMIUM',
  support: 'SUPPORT'
}

export default class Right extends Model {
  trial = false
  regular = false
  premium = false
  accesses = {
    trial: false,
    reports: false,
    sms: false,
    api: false,
    customization: false,
    team: false,
    premium: false,
    support: false
  }
  trialRemaining = null
  trialExpired = false

  constructor(json) {
    super({})
    this.premium = this.isPremium(json)
    this.trial = this.isTrial(json.subscription)
    this.regular = this.isRegular(json)
    this.accesses.trial = json.access_test
    this.trialRemaining = this.trial ? this.remainingDays(json.subscription) : 0
    this.trialExpired = this.isTrialExpired(json)
    this.accesses.sms = this.canSendSMS(json.subscription)
  }

  canSendSMS(subscription) {
    for (const o of subscription.options) {
      if (o.code.includes('SMS')) {
        return true
      }
    }
    return false
  }

  isTrial(subscription) {
    return subscription.name.toUpperCase().includes('TRIAL')
  }

  isPremium(json) {
    const name = json.subscription.name.toUpperCase()
    if (!name.includes('TRIAL') && json.subscription.options.length > 0 && !json.access_test) {
      for (const o of json.subscription.options) {
        if (o.code.includes('PREMIUM')) {
          return true
        }
      }
    }
    return false
  }

  isRegular(json) {
    if (json.access_test) {
      for (const o of json.subscription.options) {
        if (o.code.includes('PREMIUM')) {
          return false
        }
      }
      return true
    }
    return false
  }

  remainingDays(subscription) {
    return differenceInCalendarDays(Date.parse(subscription.end), Date.now())
  }

  isTrialExpired(json) {
    return !json.access_test && !this.isPremium(json)
  }

  // TODO : Parse ACCESSES
}
